import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchRecentNotifications, markNotificationAsViewed } from '@store/reducers/notifications/notificationsSlice'
import { selectRecentNotificationsData } from '@app/store/reducers/notifications/notificationsSelectors'
import { selectCurrentStateUser } from '@store/reducers/user/userSelectors'
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Dropdown,
} from 'reactstrap'
import { Badge } from 'antd'
import { Link, useHistory, useLocation } from 'react-router-dom'
import Rephrase from '@app/common/utils/Rephrase'
import { getNotificationText, checkPermission } from '@app/common/utils/helpers'
import { getNotificationRouteDict } from '@helpers/notifications'

const isUnviewed = notification => {
  return !notification.viewed || notification.viewed === 'None'
}

function NotificationsDropdownMenu({ notifications, onNotificationSelect }) {
  const hasNotifications = notifications && notifications.length > 0

  return (
    <DropdownMenu style={{ width: '500px' }} right>
      <DropdownItem header tag='div' className='text-center'><strong>Notifications</strong></DropdownItem>

      {notifications.map(n => {
        const routeDict = getNotificationRouteDict(n)

        return (
          <DropdownItem
            key={n.id}
            className='border-bottom'
            style={{ wordWrap: 'break-word' }}
            onClick={() => onNotificationSelect(routeDict)} >
            {isUnviewed(n) ? <Badge status="processing" /> : <i className={'icon-bell'} />}
            <Rephrase>{getNotificationText(n)}</Rephrase>
          </DropdownItem>
        )
      })}

      {!hasNotifications && <DropdownItem><Rephrase>{getNotificationText({ notification_type: 'no_notifications' })}</Rephrase></DropdownItem>}

      {
        hasNotifications && checkPermission('all_notifications_route')
          ? <DropdownItem header tag="div" className='text-center'>
            <Link className='dropdown-link' to={{ pathname: '/notifications' }}>
              <strong>Show all Notifications</strong>
            </Link>
          </DropdownItem>
          : null
      }
    </DropdownMenu>
  )
}


function NotificationsDropdownContainer() {
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const notifications = useSelector(selectRecentNotificationsData)
  const currentUserId = useSelector(selectCurrentStateUser)
  const [isViewingNotifications, setIsViewingNotifications] = useState(false)
  const hasNotifications = notifications && notifications.length > 0
  const hasUnviewed = hasNotifications ? notifications.some(isUnviewed) : false

  useEffect(() => {
    if (currentUserId?.data?.id) {
      dispatch(fetchRecentNotifications())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUserId])

  const navigateToNotification = (routeDict) => {
    const currentPath = location.pathname
    if (routeDict?.pathname && routeDict?.pathname === currentPath) {
      window.location.reload()
    } else {
      history.push({ pathname: routeDict.pathname, state: routeDict.state })
    }
  }

  const viewNotifications = () => {
    setIsViewingNotifications(!isViewingNotifications)

    if (!notifications || !Array.isArray(notifications)) {
      return []
    }

    const unviewedNotifications = notifications.filter(n => isUnviewed(n))

    if (unviewedNotifications.length === 0) {
      return
    }

    const updatedIDs = unviewedNotifications.map(n => n.id)
    dispatch(markNotificationAsViewed(updatedIDs))
  }

  return (
    <>
      <Dropdown nav isOpen={isViewingNotifications} toggle={viewNotifications}>
        <DropdownToggle className='' nav>
          <div className={`${hasUnviewed ? 'animated swing infinite delay-2s slow' : ''}`}>
            <Badge dot={hasUnviewed} className='mt-1'>
              <i className='icon-bell' />
            </Badge>
          </div>
        </DropdownToggle>
        <NotificationsDropdownMenu
          notifications={notifications}
          onNotificationSelect={navigateToNotification} />
      </Dropdown>
    </>
  )
}

export default NotificationsDropdownContainer
